import ProductSaleCell from './ProductSaleCell';

export default ProductSaleCell;